import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const mergeCalTagsInputSchema = z
    .object({
    fromId: requiredUuidString('Tag to merge is required.', 'Invalid tag ID.'),
    intoId: requiredUuidString('Target tag is required.', 'Invalid tag ID.'),
})
    .refine((data) => data.fromId !== data.intoId, {
    message: 'Pick two different tags to merge.',
    path: ['intoId'],
});
//# sourceMappingURL=merge-cal-tags-input.js.map